const linksOption = [
    {href: '/team', title: 'People'},
    {href: '/contact', title: 'Contact'},
    ];

const socialMediaOption = [
    {href: 'https://www.linkedin.com/company/venrock', title: 'LinkedIn'},
    {href: 'https://twitter.com/Venrock', title: 'Twitter'},
];
export default linksOption;
export {socialMediaOption};
